import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [service, setService] = useState('E-Commerce Solution')
  const [message, setMessage] = useState('')
  const [consent, setConsent] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    if (!consent) {
      alert('Please read and accept the Privacy Policy and Terms & Conditions before submitting.')
      return
    }
    const to = 'info@100eyestechnologies.com'
    const subject = `Contact from ${name || email}`
  const body = `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\nService: ${service}\n\nMessage:\n${message}`
    const mailto = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
    window.location.href = mailto
  }

  return (
    <div className="container py-5">
      <SEO title="Contact Us | 100Eyes Technologies LLP" description="Get in touch with 100Eyes Technologies — enterprise software, web & mobile development, cloud migration, and AI automation services." canonical="https://100eyestechnologies.com/contact-us" />
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <h1 className="mb-4">Contact Us</h1>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="contactName" className="form-label">Your Name</label>
              <input id="contactName" aria-label="Your Name" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control" required />
            </div>
            <div className="mb-3">
              <label htmlFor="contactEmail" className="form-label">Email</label>
              <input id="contactEmail" aria-label="Email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="form-control" required />
            </div>
            <div className="mb-3">
              <label htmlFor="contactPhone" className="form-label">Phone</label>
              <input id="contactPhone" aria-label="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} type="text" className="form-control" />
            </div>
            <div className="mb-3">
              <label htmlFor="contactService" className="form-label">Service</label>
              <select id="contactService" aria-label="Service" value={service} onChange={(e) => setService(e.target.value)} className="form-select">
                <option>E-Commerce Solution</option>
                <option>Enterprise Software & Web Solutions</option>
                <option>Travel Technology system</option>
                <option>Content Management System</option>
                <option>Custom Software/Web Solution</option>
                <option>Digital Promotion</option>
                <option>Dev Resources</option>
              </select>
            </div>
            <div className="mb-3">
              <label htmlFor="contactMessage" className="form-label">Message</label>
              <textarea id="contactMessage" aria-label="Message" value={message} onChange={(e) => setMessage(e.target.value)} className="form-control" rows={6} required />
            </div>
            <div className="mb-3 form-check">
              <input checked={consent} onChange={(e) => setConsent(e.target.checked)} type="checkbox" className="form-check-input" id="consentContact" aria-describedby="consentHelp" />
              <label className="form-check-label" htmlFor="consentContact">I have read and agree to the <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms">Terms &amp; Conditions</Link>.</label>
              <div id="consentHelp" className="form-text">We will use your information to respond to your inquiry only.</div>
            </div>
            <button type="submit" className="btn btn-primary">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  )
}
